/**
 * Native Web Share API hook.
 * Falls back gracefully on browsers that don't support sharing.
 */
export const useShare = () => {
  const canShare = typeof navigator !== 'undefined' && 'share' in navigator;

  const share = async (data: ShareData): Promise<boolean> => {
    if (!canShare) {
      return false;
    }
    try {
      // Check canShare before calling share (required for File[] sharing)
      if (navigator.canShare && !navigator.canShare(data)) {
        return false;
      }
      await navigator.share(data);
      return true;
    } catch (err) {
      // AbortError means the user cancelled — not a real error
      if (err instanceof Error && err.name === 'AbortError') {
        return false;
      }
      return false;
    }
  };

  const shareLink = async (url: string, title?: string): Promise<boolean> => {
    return await share({ url, ...(title && { title }) });
  };

  return { canShare, share, shareLink };
};
